// Data seam for the email-change confirmation link. The user clicks it from
// the NEW mailbox, possibly logged out, so this uses the same shared
// apiClient as reset-password-data.ts (it only attaches Authorization when a
// token happens to be present — works either way).
//
// Wired: confirmEmailChange -> POST /auth/email/confirm { token }
//   Resolves -> the account's email is now the new one; rejects (400/409) on
//   an expired/used/invalid token or a race where the new address got taken.

import { apiClient } from '../../api/client.js'

export interface ConfirmEmailChangeResult {
  /** 'primary': the login-email change flow (unchanged). 'secondary': this
   *  address was a notification-only secondary email, now verified — the
   *  page shows different done-copy for it (see ConfirmEmail.tsx). */
  kind: 'primary' | 'secondary'
}

/** POST /auth/email/confirm — completes a pending email change (or secondary-
 *  email verification) from the emailed link. */
export async function confirmEmailChange(token: string): Promise<ConfirmEmailChangeResult> {
  const res = await apiClient.post<{ data: ConfirmEmailChangeResult }>('/auth/email/confirm', {
    token,
  })
  return res.data.data
}
